import React from "react";
import { makeStyles } from "@material-ui/styles";
import { AuthList } from "./components";
import { Link as RouterLink } from "react-router-dom";

import { Button, SvgIcon } from "@material-ui/core";

import {PlusCircle as PlusCircleIcon } from "react-feather";
import { FormattedMessage, useIntl } from "react-intl";

const Auth = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Button
          color="primary"
          variant="contained"
          size="large"
          component={RouterLink} to={`/auth/add`}
        >
          <SvgIcon fontSize="small" className={classes.actionIcon}>
            <PlusCircleIcon />
          </SvgIcon>
          <FormattedMessage id="account_add" />
        </Button>
      </div>

      <div className={classes.content}>
        <AuthList />
      </div>
    </div>
  );
};

export default Auth;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  row: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  actionIcon: {
    marginRight: theme.spacing(1)
  }
}));